export const useAuthStore = defineStore('auth', () => {
  const universalStorage = ref<any>({})

  function getUniversal(key: string) {
    return useCookie(key).value ?? universalStorage.value[key]
  }

  function setUniversal(key: string, value: any) {
    universalStorage.value = {
      ...(universalStorage.value || {}),
      [key]: value,
    }
    const cookie = useCookie(key)
    cookie.value = value
  }

  function removeUniversal(key: string) {
    delete universalStorage.value[key]
    const cookie = useCookie(key)
    cookie.value = null
  }

  function syncUniversal(key: string, defaultValue: any) {
    if (universalStorage.value[key] === undefined) {
      universalStorage.value[key] = defaultValue
    }
  }

  return {
    universalStorage,
    getUniversal,
    setUniversal,
    removeUniversal,
    syncUniversal,
  }
})
